const env = (window as any).appletEnv as AppletEnvType

export default env
